import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { BusyModule } from '@modules/busy-module/src'
import { TranslateModule } from '@ngx-translate/core'
import { PackageComponentLanding } from './components/package/package-landing.component'
import { PackageService } from './service/package-landing.service'
import { PackageLandingExperimentComponent } from './components/package-experiment/package-landing-experiment.component'
import { SignupFlowService } from '@flowaccount/landing'

@NgModule({
  imports: [CommonModule, TranslateModule, FormsModule, BusyModule, ReactiveFormsModule],
  declarations: [PackageComponentLanding, PackageLandingExperimentComponent],
  exports: [RouterModule, PackageComponentLanding, PackageLandingExperimentComponent],
  providers: [PackageService, SignupFlowService],
})
export class DomainFinancialDomainUiFeatureSubscriptionLandingModule {}
